module.exports = __webpack_public_path__ + "static/solutions-architect-associate-216915c46acd4e419053dcdf8615373c.png";